export default function Section({ title, subtitle, actionLabel, onAction, children }) {
  return (
    <section className="px-3 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-3">
          <div>
            <h2 className="font-[Manrope] font-bold text-lg sm:text-xl text-[#1A1918]">{title}</h2>
            {subtitle && <div className="text-xs text-[#73706B] mt-0.5">{subtitle}</div>}
          </div>
          {actionLabel && (
            <button onClick={onAction} className="text-sm font-semibold text-[#E65100] hover:underline">
              {actionLabel}
            </button>
          )}
        </div>
        {children}
      </div>
    </section>
  );
}
